import React, {useEffect, useMemo, useState} from 'react';
import axios from "axios";
import {Grid, List, ListItemButton, TextField, Typography} from "@mui/material";
import styles from "../../AuctionSettingsForm/AuctionSettingsForm.module.css";
import { ZIndexContext } from '@progress/kendo-react-common';
import {Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogContentText, ListItemText} from "@material-ui/core";
import {
    Editor, EditorChangeEvent,
    EditorTools,
    EditorUtils,
    ProseMirror
} from "@progress/kendo-react-editor";
import {createInsertShortcodeTool} from '../../../components/common/inputs/RTEInsertTool/RTEInsertTool'
import {Outlet} from "@mui/icons-material";
import {DropDownButton, DropDownButtonItemClickEvent} from "@progress/kendo-react-buttons";
import {render} from "react-dom";

const EmailBody = ({eventid, massemailid, selectedRow}) => {
    const [isEmailError, setIsEmailError] = useState(false);
    const [fieldList, setFieldList] = useState<any[]>([]);

    const richTextTools = useMemo(() => {
        const InsertShortcodeTool = createInsertShortcodeTool(
            fieldList.map((f: any) => ({ text: f.fieldname, code: '<' + f.fieldname + '>', id: f.id ?? 1 }))
        );
        const edBold = EditorTools.Bold;
        return [
            [edBold, EditorTools.Italic, EditorTools.Underline, EditorTools.Strikethrough],
            [EditorTools.Subscript, EditorTools.Superscript],
            EditorTools.ForeColor,
            EditorTools.BackColor,
            [EditorTools.CleanFormatting],
            [EditorTools.AlignLeft, EditorTools.AlignCenter, EditorTools.AlignRight, EditorTools.AlignJustify],
            [EditorTools.Indent, EditorTools.Outdent],
            [EditorTools.OrderedList, EditorTools.UnorderedList],
            // [EditorTools.NumberedList, EditorTools.BulletedList],
            EditorTools.FontSize,
            EditorTools.FontName,
            EditorTools.FormatBlock,
            [EditorTools.SelectAll],
            [EditorTools.Undo, EditorTools.Redo],
            [EditorTools.Link, EditorTools.Unlink, EditorTools.InsertImage, EditorTools.ViewHtml],
            [EditorTools.InsertTable, EditorTools.InsertFile],
            // [EditorTools.Pdf, EditorTools.Print],
            [EditorTools.AddRowBefore, EditorTools.AddRowAfter, EditorTools.AddColumnBefore, EditorTools.AddColumnAfter],
            [EditorTools.DeleteRow, EditorTools.DeleteColumn, EditorTools.DeleteTable],
            [EditorTools.MergeCells, EditorTools.SplitCell],
            InsertShortcodeTool,
        ];
    }, [fieldList]);

    const [emailData, setEmailData] = useState({fieldlist: null, massemailbody: '', showbody: false, massemailfooter: '', showfooter: false, massemailheader: '', showheader: false, massemailfrom: '', massemailfromname: '', massemailid: 0, massemailsubject: ''});
    const [bodyData, setBodyData] = useState('');
    const [headerData, setHeaderData] = useState('');
    const [footerData, setFooterData] = useState('');
    const [dialogMsg, setDialogMsg] = React.useState("");



    useEffect(() => {
        const body = {'eventid': eventid, 'massemailid': massemailid}

        const fetchData = async () => {
            const { data } = await axios.post('/evtmassemailbody', body)
            const parsedData = JSON.parse(data.jsonString)
            console.log(parsedData)
            setEmailData(parsedData[0])
            setFieldList(parsedData[0]?.fieldlist || [])
            setBodyData(parsedData[0].massemailbody)
            setFooterData(parsedData[0].massemailfooter)
            setHeaderData(parsedData[0].massemailheader)
        }

        fetchData()
    }, [])

    const handleHeaderDataChange = (event: EditorChangeEvent) => {
        if (!selectedRow.readonly) {
            setHeaderData(event.html);
        }
    };
    const handleBodyDataChange = (event: EditorChangeEvent) => {
        if (!selectedRow.readonly) {
            setBodyData(event.html);
        }
    };

    const handleFooterDataChange = (event: EditorChangeEvent) => {
        console.log(event.html)
        if (!selectedRow.readonly) {
            setFooterData(event.html);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        var validEmail = true;

        if (name === 'massemailfrom') {
            const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/);
            validEmail = emailRegex.test(value)
            setIsEmailError(validEmail == false)
        }
        setEmailData({
            ...emailData,
            [name]: value
        });
    };

    const save = async () => {
        const body = {
            'eventid': eventid,
            'massemailid': massemailid,
            'massemailfrom': emailData.massemailfrom,
            'massemailfromname': emailData.massemailfromname,
            'massemailsubject': emailData.massemailsubject,
            'massemailbody': bodyData,
            'massemailheader': headerData,
            'massemailfooter': footerData
        }

        const { data } = await axios.put('/evtmassemailbody', body)
        const parsedData = JSON.parse(data.jsonString)
        var message = "Successfully saved."
        if (parsedData.message) {
            parsedData.message = message
        }
        setDialogMsg(message)
    }

    const reset = async () => {
        setBodyData('')
        setEmailData({fieldlist: null, massemailbody: '', showbody: false, massemailfooter: '', showfooter: false, massemailheader: '', showheader: false, massemailfrom: '', massemailfromname: '', massemailid: 0, massemailsubject: ''});
    }

    const closeDialog = () => {
        setDialogMsg("")
    }

    const handleHeaderToggle = (value: string) => () => {
        // const nonEditableNodeType = schema.nodes.nonEditable;
        //
        // const shortcodeNode = nonEditableNodeType.createAndFill(
        //     { class: 'shortcode' },
        //     schema.text(value)
        // );
        setHeaderData(headerData + '{{' + value + '}}')
    }

    const handleBodyToggle = (value: string) => () => {
        // const nonEditableNodeType = schema.nodes.nonEditable;
        //
        // const shortcodeNode = nonEditableNodeType.createAndFill(
        //     { class: 'shortcode' },
        //     schema.text(value)
        // );
        setBodyData(bodyData + '{{' + value + '}}')
    }

    const handleFooterToggle = (value: string) => () => {
        // const nonEditableNodeType = schema.nodes.nonEditable;
        //
        // const shortcodeNode = nonEditableNodeType.createAndFill(
        //     { class: 'shortcode' },
        //     schema.text(value)
        // );
        console.log(footerData)
        setFooterData(footerData + '{{' + value + '}}')
        console.log(footerData)
    }

    const { Schema, EditorView, EditorState } = ProseMirror;
    const { Bold, Italic, Underline, ViewHtml } = EditorTools;

    const nonEditable = {
        name: "nonEditable",
        inline: true,
        group: "inline",
        content: "inline+",
        marks: "",
        attrs: {
            contenteditable: { default: null },
            class: { default: null },
            style: { default: null }
        },
        atom: true,
        parseDOM: [{ tag: "span.uneditable", priority: 51 }],
        // The styles can be added via the class as well
        toDOM: () => [
            "span",
            {
                contenteditable: false,
                class: "uneditable",
                style: "user-select: none;"
            },
            0
        ]
    };

    const onMount = event => {
        console.log('ONMOUNT')
        console.log(event)
        const { viewProps } = event;
        const { plugins, schema } = viewProps.state;

        // Append a new node.
        let nodes = schema.spec.nodes.addToEnd('nonEditable', nonEditable);

        // Create the new schema.
        const mySchema = new Schema({ nodes: nodes, marks: schema.spec.marks });

        // Create a new document using the modified schema.
        const doc = EditorUtils.createDocument(mySchema, '');

        // Return the custom EditorView object that will be used by Editor.
        return new EditorView(
            { mount: event.dom },
            {
                ...event.viewProps,
                state: EditorState.create({ doc, plugins })
            }
        );
    }

    return (
        <>
            <>
                <Dialog
                    open={dialogMsg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Ok</Button>
                    </DialogActions>
                </Dialog>
            </>
            <div style={{padding: 20}}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField disabled={selectedRow.readonly} name={"massemailfromname"} label={"From Name:"}
                                   value={emailData.massemailfromname} onChange={handleInputChange} fullWidth/>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField disabled={selectedRow.readonly} name={"massemailfrom"} label={"From Email:"}
                                   helperText={isEmailError ? 'Please enter a valid email.' : ' '}
                                   error={isEmailError}
                                   value={emailData.massemailfrom} onChange={handleInputChange} fullWidth/>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField disabled={selectedRow.readonly} name={"massemailsubject"} label={"Subject:"}
                                   value={emailData.massemailsubject} onChange={handleInputChange} fullWidth/>
                    </Grid>
                    {emailData.showheader &&
                        <>
                            <ZIndexContext.Provider value={10003}>
                            <Grid item xs={12}>
                                <h4>Header</h4>
                            </Grid>
                            <Grid item xs={10}>
                                <Editor
                                    value={headerData}
                                    onChange={(e) => handleHeaderDataChange(e)}
                                    tools={richTextTools}
                                    contentStyle={{height: 300}}
                                    onMount={onMount}
                                />
                            </Grid>
                            </ZIndexContext.Provider>
                        </>
                    }
                    {emailData.showbody &&
                        <>
                            <ZIndexContext.Provider value={10003}>
                            <Grid item xs={12}>
                                <h4>Body</h4>
                            </Grid>
                            <Grid item xs={10}>
                                <Editor
                                    value={bodyData}
                                    onChange={(e) => handleBodyDataChange(e)}
                                    tools={richTextTools}
                                    contentStyle={{height: 300}}
                                    onMount={onMount}/>
                            </Grid>
                            </ZIndexContext.Provider>
                        </>}

                    {emailData.showfooter &&
                        <>
                            <ZIndexContext.Provider value={10003}>
                            <Grid item xs={12}>
                                <h4>Footer</h4>
                            </Grid>
                            <Grid item xs={10}>
                                <Editor
                                    value={footerData}
                                    onChange={(e) => handleFooterDataChange(e)}
                                    tools={richTextTools}
                                    contentStyle={{height: 300}}
                                    onMount={onMount}/>
                            </Grid>
                            </ZIndexContext.Provider>
                        </>}

                    <Grid item xs={6}>
                        <Button disabled={selectedRow.readonly || isEmailError} type="submit" variant="contained"
                                className={styles.button} onClick={save} fullWidth>
                            Save
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button disabled={selectedRow.readonly} type="submit" variant="contained"
                                className={styles.button} onClick={reset} fullWidth>
                            Reset
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}
export default EmailBody

